import { trackEvent } from '@/shared/analytics';
import { extractErrorMessages } from '@/shared/utils/typeGuards';
import { toSnakeCase } from '@/shared/utils/string';

export function trackFormServerErrors(error: unknown, formType: string): void {
  for (const [field, messages] of Object.entries(extractErrorMessages(error))) {
    trackEvent('form_server_error', {
      field_name: toSnakeCase(field),
      error_message: messages[0],
      form_type: formType,
    });
  }
}
